import './SafeArea.less';
import SafeArea from './SafeArea';

export default SafeArea;
